import { IsoLocale, CurrencyUtil } from '@izettle/constants';
import { getLocale } from '@izettle/react';

class Translator {
  onTranslationMissing = key => {
    if (this.isProd) {
      // eslint-disable-next-line no-console
      console.error(`Missing translation for "${key}"`);
    }
    return this.isProd ? "" : key;
  };
  modeConfig = {};
  isProd = process.env.APP_ENV === "production";
  constructor(_ref) {
    let {
      locale,
      defaultLocale,
      translations,
      onTranslationMissing,
      fallbackDisabled,
      ...modeConfig
    } = _ref;
    this.modeConfig = {
      ...this.modeConfig,
      ...modeConfig
    };
    this.setLocaleVars(locale ?? Translator.optionsFromIsoLocale(getLocale(window.navigator.languages) ?? defaultLocale ?? IsoLocale.enGB));
    this.translations = translations ?? null;
    this.fallbackDisabled = fallbackDisabled ?? false;
    this.onTranslationMissing = onTranslationMissing ?? this.onTranslationMissing;
  }
  static optionsFromIsoLocale(locale) {
    if (locale == null) {
      return null;
    }
    return {
      country: locale.slice(locale.indexOf("-") + 1),
      language: locale.slice(0, locale.indexOf("-"))
    };
  }
  static isoLocaleFromOptions(options) {
    return `${options.language}-${options.country}`;
  }
  setLocaleVars(options) {
    this.locale = Translator.isoLocaleFromOptions(options);
    this.country = options.country;
    this.language = options.language;
    this.currency = options.currency ?? CurrencyUtil.fromCountry(this.country);
  }
  translate = key => {
    if (!this.translations) {
      return this.isProd ? "" : key;
    }
    const translation = this.translations[key.toUpperCase()];
    if (translation == null) {
      return this.onTranslationMissing(key);
    }
    return translation;
  };

  /* istanbul ignore next */
  importFile = async locale => {
    // eslint-disable-next-line import/dynamic-import-chunkname
    const result = await import( /* webpackChunkName: "[request]" */
    /* webpackMode: "lazy" */
    /* webpackPreload: true */
    /* webpackInclude: /i18n\..*?\.json$/ */
    `@translations/localized/i18n.${locale}.json`).catch(err => err);
    if (result instanceof Error || result.message != null && result.stack != null) {
      // eslint-disable-next-line no-console
      console.error(`Failed to fetch translations for ${locale} ${result.message ?? ""}`);
      return null;
    }
    return result;
  };
  loadTranslations = (() => {
    var _this = this;
    return async function () {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const locale = options.override ? Translator.isoLocaleFromOptions(options.override) : _this.locale;
      let localeBody = await _this.importFile(locale);
      if (localeBody == null && locale !== IsoLocale.enGB && !_this.fallbackDisabled) {
        localeBody = await _this.importFile(IsoLocale.enGB);
      }
      if (localeBody == null) {
        throw new Error("Could not load any translations.");
      }
      _this.translations = localeBody;
      _this.setLocaleVars(Translator.optionsFromIsoLocale(locale));
    };
  })();
}

export { Translator };
//# sourceMappingURL=translator.js.map
